import React, {useEffect, useState, useRef} from 'react';
import MediaCarouselModalFullWidthProps from "./props";
import MediaCarousel from '../MediaCarousel';
import { EmblaCarouselHandle } from '../EmblaCarousel/props';
import './styles.scss';
import ImageCounterPanel from '../../private/ImageCounterPanel';
import closeIcon from '../../../icons/close-thin-white.svg';

function MediaCarouselModalFullWidth(props: MediaCarouselModalFullWidthProps) {
  const { open, onClose, items, initialIndex } = props;
  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);
  const carouselRef = useRef<EmblaCarouselHandle>(null);

  // Focus on the carousel when the modal is opened
  useEffect(() => {
    carouselRef?.current?.focus();
  }, []);

  // Handle keyboard events (ESC and arrow keys)
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (!open) return;
    
      if (event.key === 'Escape') {
        onClose(event, currentIndex);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        carouselRef.current?.goToPrevious();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        carouselRef.current?.goToNext();
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [open, onClose, currentIndex]);

  if (!open) return null;

  const handleIndexChange = (index: number) => {
    setCurrentIndex(index);
  };
  const onClickClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClose(event?.nativeEvent, currentIndex);
  }

  return (
    <div className='carousel-modal-full-width' data-e2e='carousel-modal-full-width'>
        <div className='carousel-modal-full-width__top-container'>
          <ImageCounterPanel show={true} count={currentIndex + 1} total={props.items.length} />
          <button className='carousel-modal-full-width__close-button' onClick={onClickClose}>
            <span>{props.closeButtonText}</span>
            <img src={closeIcon} alt="Close Modal Button Icon" />
          </button>
        </div>
        <div className='carousel-modal-full-width__media-carousel-container'>
          <MediaCarousel
            ref={carouselRef}
            fullWidth={true}
            draggable={props.draggable}
            draggable360Image={props.draggable360Image}
            items={items}
            initialIndex={initialIndex}
            hideArrowButtons={props.hideArrowButtons}
            swipeVideosOverlay={props.swipeVideosOverlay || true}
            handleCarouselItemClick={props.handleCarouselItemClick}
            prevOnClick={props.prevOnClick}
            nextOnClick={props.nextOnClick}
            onSelectedIndexChange={handleIndexChange}
          />
        </div>
    </div>
  );
}

export default React.memo(MediaCarouselModalFullWidth);
